import { render, staticRenderFns } from "./SeguroHogar.vue?vue&type=template&id=3c89a739&scoped=true&"
import script from "./SeguroHogar.vue?vue&type=script&lang=js&"
export * from "./SeguroHogar.vue?vue&type=script&lang=js&"
import style0 from "./SeguroHogar.vue?vue&type=style&index=0&id=3c89a739&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c89a739",
  null
  
)

export default component.exports